import CalculateDistance from '../lib/calculate-distance';
import googleLoader from '../lib/google-loader';
import Utilities from '../helpers/utilities';
import RoleFavouriting  from './roleFavouriting';

export default class {

    constructor() {

        this.counter = $('.filtered-roles-count');
        this.roleFinder = $('.role-finder-results');
        this.bases = this.roleFinder.data('bases');
        this.currentQualification = '';
        this.currentRank = '';
        this.roleFavouriting = new RoleFavouriting();
        this.noFavsBlock = $('.no-favourites');
        this.noFavsBlock.hide();
        this.setEvents();
        this.roletypeToggle(); // will also update the counter etc

        var preselectedQualification = new Utilities().getUrlVars()['qualification'];
        switch(preselectedQualification) {
            case "Further-qualification":
                $('input[name=qualification][value="Further qualification"]').prop('checked', true);    
                $('input[type=radio][name=qualification]').trigger('change');
                break;
            case 'university-degree':
                $('input[name=qualification][value="University degree"]').prop('checked', true);    
                $('input[type=radio][name=qualification]').trigger('change');
                break;
            case 'a-levels':
                $('input[name=qualification][value="A-levels"]').prop('checked', true);          
                $('input[type=radio][name=qualification]').trigger('change');
                break;
            case 'gcses':
                $('input[name=qualification][value="GCSES"]').prop('checked', true);          
                $('input[type=radio][name=qualification]').trigger('change');
                break;
            case 'no-qualifications':
                $('input[name=qualification][value="No qualifications"]').prop('checked', true);          
                $('input[type=radio][name=qualification]').trigger('change');
                break;
        }

        if ($('.role-finder-filter-container').data('filterstartsopen') == 'True') {
            $('.role-finder-filter-wrapper').show();    
            $('.role-finder-filter-clearfilters').show();
            $('.role-finder-filter-container-header-image[data-imagetype="filter"]').hide();
            $('.role-finder-filter-container-header-image[data-imagetype="close"]').show();

            const $ageWrapper = $('.role-finder-filter-dropdownwrapper[data-filter="age"]');
            if ($ageWrapper.length) {
                const $panel = $('.role-finder-filter[data-filter="age"]');
                const $dropdown = $ageWrapper.find('.role-finder-filter-dropdown');
                $ageWrapper.addClass('active');
                $dropdown.attr('aria-expanded', 'true');
                $panel.show().attr('aria-hidden', 'false');
            }            
        }                  

        if ($('.role-finder-filter-container').data('gotofavourites') == 'True') {
            $('html').scrollTop($('.role-finder-filter-info').position().top - 316);
        }
    }

    setEvents() {
        var self = this;

        self.moveFilter();

        $('.role-finder-filter-wrapper').hide();
        $('.role-finder-filter-clearfilters').hide();

        $('.role-finder-filter-container-header').on('click', function() {
            var shown = $('.role-finder-filter-wrapper').is(":visible");
            if (shown) {
                $('.role-finder-filter-wrapper').slideUp();
                $('.role-finder-filter-clearfilters').slideUp();
                $('.role-finder-filter').hide();
                $('.role-finder-filter-dropdownwrapper').removeClass('active');                   
                $('.role-finder-filter-container-header-image[data-imagetype="close"]').hide();
                $('.role-finder-filter-container-header-image[data-imagetype="filter"]').show();
            } else {    
                $('.role-finder-filter-wrapper').slideDown();    
                $('.role-finder-filter-clearfilters').slideDown();
                $('.role-finder-filter-container-header-image[data-imagetype="filter"]').hide();
                $('.role-finder-filter-container-header-image[data-imagetype="close"]').show();
            }
        });        

        $('.roletype-toggle-checkbox').on('click', function() {
           self.roletypeToggle();
        });

        $('.role-finder-filter-dropdown').on('click', function() {
            if ($(this).parent().hasClass('disabled'))
                return false;
            self.showFilter($(this).parent());
        });

        $('.role-finder-filter-dropdown').on('keydown', function(e) {
            if (e.key == 'Enter' || e.key == ' ') {
                e.preventDefault();
                if ($(this).parent().hasClass('disabled'))
                    return false;
                self.showFilter($(this).parent());
            }
        });

        this.ageEvents();
        this.qualificationEvents();
        this.interestEvents();
        this.locationEvents();
        this.rankEvents();
        this.sortTypeEvents();

        $('#ClearFilterButton').on('click', function() {
            self.clearFilters();
        });

        $('#favouritesCheckbox').on('click', (e) => {            
            this.sortResults();
            this.showHideNoFavouritesBlock();            
        });
    }
    
    showHideNoFavouritesBlock() {                
        if (this.noFavsBlock.length > 0) {
            if ($('#favouritesCheckbox').is(':checked')) {
                let favFound = false;
                $('.favourite-button').each(function() {
                    if (!$(this).prop('adds'))
                        favFound = true;
                });
                if (favFound) {
                    this.noFavsBlock.hide();
                } else {
                    this.noFavsBlock.show();
                }
            } else {            
                this.noFavsBlock.hide();
            }
        }        
    }

    ageEvents() {
        var self = this;       
        $('#AgeSlider').on('input change', function() {
            self.ageChanged();
        });    
        $('#AgeMinus').on('click', function() {
            var ageSlider = document.getElementById('AgeSlider');
            if (ageSlider.value > ageSlider.min) {
                ageSlider.stepDown();
                self.ageChanged();
            }
        });
        $('#AgePlus').on('click', function() {
            var ageSlider = document.getElementById('AgeSlider');
            if (ageSlider.value < ageSlider.max) {
                if ($('#AgeSliderValue').html() == '?') {
                    ageSlider.value == 16;
                } else {
                    ageSlider.stepUp();
                }                
                self.ageChanged();
            }
        });
    }

    ageChanged() {
        if ($('#AgeSlider').val() == 0) {
            $('#AgeSliderValue').html('?');
        } else {
            $('#AgeSliderValue').html($('#AgeSlider').val());
        }
        
        $('.role-finder-filter-dropdownwrapper[data-filter="age"]').find('.additional-label').text('(' + $('#AgeSlider').val() + ' yrs)' );
        this.filterResults();
    }

    qualificationEvents() {
        var self = this;
        $('input[type=radio][name=qualification]').on('click', function() {                        
            var selectedValue = $(this).val();            
            if (selectedValue == self.currentQualification) {
                $(this).prop('checked', false);
                self.currentQualification = '';
                $('.role-finder-filter-dropdownwrapper[data-filter="qualification"]').find('.additional-label').text('');        
                self.filterResults();
            }            
        });
        $('input[type=radio][name=qualification]').on('change', function() {     
            self.currentQualification = $('input[name="qualification"]:checked').val(); 
            $('.role-finder-filter-dropdownwrapper[data-filter="qualification"]').find('.additional-label').text('(1)');        
            self.filterResults();
        });
    }

    interestEvents() {
        var self = this;
        $('.interests-checkbox').on('change', function() {
            self.interestsChanged();            
        });
    }

    locationEvents() {

        var self = this;
        
        $("#LocationInput").on('keypress', function(e) {
            if (e.which == 13) {
                self.searchBases();
            }
        });

        $('.locations-form-submit').on('click', function(e) {
            e.preventDefault();
            self.searchBases();
        });

        $('#LocationResults').on('click', '.role-finder-basechip', function() {
            $(this).toggleClass('active');
            var selectedCount = $('.role-finder-basechip.active').length;
            if (selectedCount > 0) {
                $('.role-finder-filter-dropdownwrapper[data-filter="location"]').find('.additional-label').text('(' + selectedCount + ')');        
            } else {
                $('.role-finder-filter-dropdownwrapper[data-filter="location"]').find('.additional-label').text('');        
            }
            self.filterResults() 
        });
    }

    rankEvents() {
        var self = this;
        
        $('input[type=radio][name=rank]').on('click', function() {                        
            var selectedValue = $(this).val();            
            if (selectedValue == self.currentRank) {
                $(this).prop('checked', false);
                self.currentRank = '';
                $('.rank-dropdown-label').text('Rank');     
                self.filterResults();
            }            
        });
        $('input[type=radio][name=rank]').on('change', function() {     
            self.currentRank = $('input[name="rank"]:checked').val(); 
            if (self.currentRank == undefined) {
                $('.rank-dropdown-label').text('Rank');
            } else {
                $('.rank-dropdown-label').text($('input[name="rank"]:checked').data('dropdownlabel'));
            }
            self.filterResults();
        });
    }

    sortTypeEvents() {
        var self = this;
        var $button = $('.sort-type');
        var $optionsList = $('.sort-options');
        var $options = $('.sort-option');

        // Set ARIA roles
        $button.attr({
            'role': 'button',
            'aria-haspopup': 'listbox',
            'aria-expanded': 'false'
        });
        $optionsList.attr('role', 'listbox');
        $options.attr('role', 'option').attr('tabindex', '-1');

        var open = false;
        var focusedIndex = 0;

        function openMenu() {
            $('.sort-type-wrapper').addClass('active');
            $optionsList.show();
            $button.attr('aria-expanded', 'true');
            // Focus selected or first
            focusedIndex = $options.index($('.sort-option.selected')) || 0;
            $options.eq(focusedIndex).attr('tabindex', '0').focus();
            open = true;
        }

        function closeMenu() {
            $('.sort-type-wrapper').removeClass('active');
            $optionsList.hide();
            $button.attr('aria-expanded', 'false');
            $button.focus();
            open = false;
        }

        function moveFocus(direction) {
            $options.eq(focusedIndex).attr('tabindex', '-1');
            focusedIndex = (focusedIndex + direction + $options.length) % $options.length;
            $options.eq(focusedIndex).attr('tabindex', '0').focus();
        }

        function selectOption(index) {
            $options.removeClass('selected').attr('aria-selected', 'false');
            $options.eq(index).addClass('selected').attr('aria-selected', 'true');
            $('.sort-type-text').text($options.eq(index).text());
            closeMenu();
            self.sortResults();
        }

        // Click to open/close
        $button.on('click', function() {
            if (open) {
                closeMenu();
            } else {
                openMenu();
            }

            // Rotate icon
            var arrow = $(this).find('img');
            arrow.toggleClass('rotate90 rotate270');
        });

        // Keyboard on button
        $button.on('keydown', function(e) {
            if ((e.key === 'Enter' || e.key === ' ') && !open) {
                e.preventDefault();
                openMenu();
            } else if (e.key === 'Escape' && open) {
                e.preventDefault();
                closeMenu();
            }
        });

        // Keyboard on options
        $options.on('keydown', function(e) {
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                moveFocus(1);
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                moveFocus(-1);
            } else if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                selectOption(focusedIndex);
            } else if (e.key === 'Escape') {
                e.preventDefault();
                closeMenu();
            }
        });

        // Mouse click on option
        $options.on('click', function() {
            selectOption($options.index(this));
        });
    }

    searchBases() {                    
        googleLoader().then(google => {
            this.calculateDistance = new CalculateDistance(google);    
            const getBases = async (retries = 0) => {        
                if (this.calculateDistance) {                    
                    try {                    
                        const results = await this.calculateDistance.selectBasesInRange($('#LocationInput').val(), this.bases, 65);
                        this.removeBaseChips();
                        if (results) {
                            this.addBaseChipsHeader();
                            results.forEach((val) => this.addBaseChip(val.Title, val.Distance));    
                        }
                        this.filterResults();                 
                    } catch(error) {
                        this.removeBaseChips();
                        console.error(error);
                    }
                } else {
                    if (retries <= 50) {
                        setTimeout(async () => {
                            await getBases(retries + 1);
                        }, 200);
                    }
                }
            }            
            getBases();                                
        });
    }

    removeBaseChips() {
        $('#LocationResults').html('');
    }

    addBaseChipsHeader() {
        var header = '<div class="role-finder-basechips-header">Filter by the RAF bases near you:</div>';
        $('#LocationResults').append(header);
    }

    addBaseChip(name, distance) {
        var distanceDisplay = '(' + distance.slice(0, -1) + ' miles)'
        var newChip = '<div class="role-finder-basechip" data-basename="' + name + '"><div class="role-finder-basechip-name">' + name + '</div><div class="role-finder-basechip-distance">' + distanceDisplay + '</div></div>'
        $('#LocationResults').append(newChip);
    }

    showFilter($selectedFilterParent) {     

        const filterName = $selectedFilterParent.data('filter');
        const $panel = $('.role-finder-filter[data-filter="' + filterName + '"]');
        const $dropdown = $selectedFilterParent.find('.role-finder-filter-dropdown');
        const isActive = $selectedFilterParent.hasClass('active');

        if (isActive) { 
            $selectedFilterParent.removeClass('active');
            $panel.slideUp(() => {
                $panel.attr('aria-hidden', 'true');
            });
            $dropdown.attr('aria-expanded', 'false');
        } else {
            $('.role-finder-filter-dropdownwrapper').removeClass('active');
            $('.role-finder-filter').slideUp().attr('aria-hidden', 'true');
            $('.role-finder-filter-dropdown').attr('aria-expanded', 'false');
            $selectedFilterParent.addClass('active');
            $dropdown.attr('aria-expanded', 'true');
            $panel.slideDown(() => {
                $panel.attr('aria-hidden', 'false');
            });
        }
    }

    moveFilter() {
        var self = this;
        $('.role-finder-filter').each(function() {            
            $('.role-finder-filter-dropdownwrapper[data-filter="' + $(this).data('filter') + '"]').first().after($(this));
        })
    }

    interestsChanged() {
        var max = 3;
        var count = $('.interests-checkbox:checkbox:checked').length;
        
        if (count == max) {
            $('.interests-checkbox-desktop:checkbox:not(:checked)').attr('disabled', true);            
            $('.interests-checkbox:checkbox:not(:checked)').attr('disabled', true);            
        } else {
            $('.interests-checkbox-desktop:checkbox').removeAttr('disabled');
            $('.interests-checkbox:checkbox').removeAttr('disabled');
        }

        if (count == 0) {
            $('.role-finder-filter-dropdownwrapper[data-filter="interests"]').find('.additional-label').text('');               
            this.roleFinder.prop('data-interests', '');  
        } else {
            $('.role-finder-filter-dropdownwrapper[data-filter="interests"]').find('.additional-label').text('(' + count + ')');   
            var interests = '';
            $('.interests-checkbox:checkbox:checked').each(function() {
                interests += $(this).val();
                interests += ',';
            });
            this.roleFinder.prop('data-interests', interests.substring(0, interests.length - 1));
        }

        this.sortResults();
    }

    roletypeToggle() {
        if ($('.roletype-toggle-checkbox').is(':checked')) {
            $('.roletype-toggle').addClass('reserves');
            $('.role-finder-result--link').each(function() {
                var href = $(this).attr('href');
                $(this).attr('href', href + '?time=reserve');
            });
            this.enableFilter('location', true);
        } else {
            $('.roletype-toggle').removeClass('reserves');   
            $('.role-finder-result--link').each(function() {
                var href = $(this).attr('href');
                if (href.indexOf('?') !== -1) {
                    $(this).attr('href', href.split('?')[0]);
                 }                 
            });
            this.enableFilter('location', false);
        }
        this.filterResults();
    }

    enableFilter(filter, enable) {
        if (enable) {
            $('.role-finder-filter-dropdownwrapper[data-filter="' + filter + '"]').removeClass('disabled');
        } else {
            $('.role-finder-filter[data-filter="' + filter + '"]').hide();
            $('.role-finder-filter-dropdownwrapper[data-filter="' + filter + '"]').addClass('disabled');                    
            $('.role-finder-filter-dropdownwrapper[data-filter="' + filter + '"]').removeClass('active'); 
        }
    }

    filterResults() {
        var self = this;
        self.setTotalFilteredCount()
        $('.role-finder-result').each(function() {
            var roleResult = $(this);
            if (self.roleHasRegularOrReserve(roleResult) &&
                self.roleHasAge(roleResult) &&
                self.roleHasQualification(roleResult) &&
                self.roleHasRank(roleResult) &&
                self.roleHasLocation(roleResult)) {
                roleResult.show();
            } else {
                roleResult.hide();
            }
        });
        self.updateCounter();
        self.sortResults();
    }

    setTotalFilteredCount() {
        var ageFiltered = $('#AgeSliderValue').html() == '?' ? 0 : 1;
        var qualificationFiltered = this.currentQualification != '' ? 1 : 0;
        var interestFiltered = $('.interests-checkbox:checkbox:checked').length;
        var locationFiltered = $('.role-finder-basechip.active').length;
        var totalCount = ageFiltered + qualificationFiltered + interestFiltered + locationFiltered;

        if (totalCount > 0) {
            $('.total-filtered-count').text('(' + totalCount + ' applied)');
        } else {
            $('.total-filtered-count').text('');
        }
    }

    roleHasRegularOrReserve(roleResult) {      
        if ($('.roletype-toggle-checkbox').is(':checked')) {
            return roleResult.data('showforreserve') == 'True';
        } else {
            return roleResult.data('showforregular') == 'True'
        }  
    }

    roleHasAge(roleResult) {
            
        if ($('#AgeSliderValue').html() == '?')
            return true;

        var selectedAge = $('#AgeSlider').val();
        
        if ($('.roletype-toggle-checkbox').is(':checked')) {
            return roleResult.data('agesreserve').split(',').includes(selectedAge);
        } else {
            return roleResult.data('agesregular').split(',').includes(selectedAge);
        }  
    }

    roleHasQualification(roleResult) {
        var selectedQualification = $('input[name="qualification"]:checked').val();
        if (selectedQualification == undefined)
            return true;
        return roleResult.data('qualifications').toLowerCase().split(',').includes(selectedQualification.toLowerCase());
    }

    roleHasRank(roleResult) {
        var selectedRank = $('input[name="rank"]:checked').val();
        if (selectedRank == undefined)
            return true;
        switch(selectedRank) {
            case 'All':
                return true;
            case 'Aviator':
                return roleResult.data('roleclassification') != 'Officer';
            case 'Officer':
                return roleResult.data('roleclassification') == 'Officer';
        }
    }

    roleHasLocation(roleResult) {
        if (!$('.roletype-toggle-checkbox').is(':checked')) {
            return true;
        }

        var selectedBases = $('.role-finder-basechip.active');
        if (selectedBases.length < 1) {
            return true;
        }

        var include = false;
        $('.role-finder-basechip.active').each(function() {
            if (roleResult.data('bases').toLowerCase().split(',').includes($(this).data('basename').toLowerCase())) {
                include = true;
                return false;
            }
        })
               
        return include;
    }

    updateCounter() {
        this.counter.text($('.role-finder-result:visible').length);        
    }

    clearFilters() {

        // Age
        $('#AgeSlider').val(0);
        $('#AgeSliderValue').html('?');

        // Qualification 
        $('input[name="qualification"]:checked').prop('checked', false);
        
        // Interests
        $('.interests-checkbox:checkbox:checked').prop('checked', false);
        $('.interests-checkbox').prop('disabled', false);
        this.roleFinder.prop('data-interests', '');

        // Rank
        $('input[name="rank"]:checked').prop('checked', false);        
        $('.rank-dropdown-label').text('Rank');
        
        // Location        
        $('#LocationInput').val('');
        this.removeBaseChips();

        $('.additional-label').text('');

        this.filterResults();
    }

    sortResults() {
        // favsort: 0 = favourite, 1 = not favourite
        switch($('.sort-type').text().replace(/\s+/g, ' ').trim()) {                        
            case 'A - Z': {
                var results = $('.role-finder-result');
                results.sort(function(a, b) {
                    if ($('#favouritesCheckbox').is(':checked')) {
                        var valueA = $(a).data('favsort') + $(a).data('name').toLowerCase();
                        var valueB = $(b).data('favsort') + $(b).data('name').toLowerCase();
                        return String.prototype.localeCompare.call(valueA, valueB);
                    } else {
                        return String.prototype.localeCompare.call($(a).data('name').toLowerCase(), $(b).data('name').toLowerCase());
                    }
                });
                $('.role-finder-results-container').html(results);
                break;
            }
            case 'Z - A': {
                var results = $('.role-finder-result');
                results.sort(function(a, b) {        
                    if ($('#favouritesCheckbox').is(':checked')) { 
                        var valueA = ($(a).data('favsort') == '1' ? '0' : '1') + $(a).data('name').toLowerCase();
                        var valueB = ($(b).data('favsort') == '1' ? '0' : '1') + $(b).data('name').toLowerCase();
                        return String.prototype.localeCompare.call(valueB, valueA);
                    } else {
                        return String.prototype.localeCompare.call($(b).data('name').toLowerCase(), $(a).data('name').toLowerCase());
                    }
                });
                $('.role-finder-results-container').html(results);
                break;
            }
            default: {     
                var self = this;
                $('.role-finder-result').each(function() {
                    var sortScore = self.sortScore(this);
                    $(this).prop('data-sortscore', sortScore);
                });        
                var results = $('.role-finder-result');
                results.sort(function(a, b) {            
                    return $(b).prop('data-sortscore')-$(a).prop('data-sortscore');
                });
                $('.role-finder-results-container').html(results);
                break;
            }
        }
        this.roleFavouriting.setFavourites();
    }
    
    sortScore(roleResult) {
        roleResult = $(roleResult);          
        var score = roleResult.data('rolesortingindex'); 

        var qualificationMultipler = 1000;
        var selectedQualification = $('input[name="qualification"]:checked').val();   
        if (selectedQualification != undefined && selectedQualification != '') {    
            switch (roleResult.data('qualificationaim')) {
                case "Further qualification":
                    qualificationMultipler = 8000;
                    break;
                case "University degree":
                    qualificationMultipler = 5000;
                    break;
                case "A-levels":
                    qualificationMultipler = 2000;
                    break;
            }
            score = score + (2.5 * qualificationMultipler);
        }
          
        var selectedInterests = this.roleFinder.prop('data-interests');
        if (selectedInterests != undefined && selectedInterests != '') {
            selectedInterests = selectedInterests.split(',');
            $.each(roleResult.data('interests').split(','), function() {
                if ($.inArray(this, selectedInterests) != -1) {
                    score = score + qualificationMultipler;
                }
            });
        }

        if ($('#favouritesCheckbox').is(':checked') && roleResult.data('favsort') == '0') {
            score = score + 100000;
        }

        return score;
    }
}
